import { classNames } from '~/utils/styles';
import type { SegmentedBarProps } from './SegmentedBar.types';

/** A horizontal bar split into proportional segments. */
export function SegmentedBar({ segments, className, 'aria-label': ariaLabel }: SegmentedBarProps) {
  const total = segments.reduce((sum, segment) => sum + Math.max(0, segment.value), 0);

  return (
    <div
      aria-label={ariaLabel}
      className={classNames('flex h-2 w-full overflow-hidden bg-neutral-200', className)}
      role="img"
    >
      {segments.map((segment) => {
        const share = total > 0 ? Math.max(0, segment.value) / total : 0;

        return (
          <div
            className={classNames(
              'h-full flex-none transition-[width] duration-200 motion-reduce:transition-none',
              segment.colorClassName,
            )}
            data-testid={`segmented-bar-segment-${segment.key}`}
            key={segment.key}
            // The width follows the data, which no static class can express.
            style={{ width: `${share * 100}%` }}
          />
        );
      })}
    </div>
  );
}
